import {FormattedMessage} from 'react-intl';
import {NavLink} from 'react-router-dom';
import {Display} from 'shared/components';
import {observer} from 'mobx-react';
import {t} from 'shared/core';

const ExpensesSubnav = observer(({scope}) => {
  return (
    <Display title={t('expenses.Expenses')}>
      {scope.myExpenses && <NavLink exact to='/' activeClassName='active'>
        <FormattedMessage id='expenses.subnav.My Expenses'/>
      </NavLink>}
      {scope.expenseRequests && <NavLink to='/expense_requests' activeClassName='active'>
        <FormattedMessage id='expenses.subnav.Expense Requests'/>
      </NavLink>}
      {scope.manage && <NavLink to='/manage' activeClassName='active'>
        <FormattedMessage id='expenses.subnav.Manage'/>
      </NavLink>}
    </Display>
  );
});

export default ExpensesSubnav;
